<template>
<div class="modal questionnaire">
  <div class="modal_overlay" :class="{ showfiche: true}">
    <div class="modal_wrap">
      <div class="modal_header">
        <div class="modal_header_title questionnaire-titre">
          <p>{{ this.$store.state.questionnaire.titre }}</p>
          <label for="modal_trigger" @click="close" class="close_modal"></label>
        </div>
        <hr />
      </div>
      <div class="questionnaire-message" v-html="this.$store.state.questionnaire.message">
      </div>
      <!-- MODAL FOOTER -->
      <div class="modal_footer footer">
        <div class="item item-questionnaire" @click="go">{{ $t("message['Accéder au questionnaire']") }}</div>
        <div class="item item-questionnaire" @click="forget">{{ $t("message['Ne plus demander']") }}</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import storeJs from 'store'

export default {
  name: 'Questionnaire',
  components: {},

  props: [],

  data() {
    return {}
  },

  created() {},

  destroyed() {},

  methods: {
    go() {
      this.openUrl(this.$store.state.questionnaire.url, '_blank')
      this.hideInFuture()
      this.close()
    },
    forget() {
      this.hideInFuture()
      this.close()
    },
    close() {
      this.$store.dispatch('unsetQuestionnaire')
    },
    hideInFuture() {
      let questionnaireId = this.$store.state.questionnaire.id
      // Durée : this.$store.state.questionnaire.dureesec?this.$store.state.questionnaire.dureesec:60*60*24*31
      storeJs.set('cr:hide-survey' + questionnaireId, true)
    },
    openUrl(url, target) {
      var referLink = document.createElement('a')
      referLink.href = url
      if (target) {
        referLink.target = target
      }
      document.body.appendChild(referLink)
      referLink.click()
      document.body.removeChild(referLink)
    }
  }
}
</script>

<style scoped>
.modal.questionnaire .modal_overlay {
  text-align: left;
}

.modal.questionnaire .questionnaire-message {
  margin: 10px;
}

.modal .footer {
  background-color: #007abc;
  height: 40px;
  position: absolute;
  width: 100%;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal .footer .item {
  font-size: 1.1em;
  color: #fff;
  cursor: pointer;
  margin-top: 6px;
  margin-left: 10px;
  margin-right: 10px;
}

.modal .footer .item:hover {
  color: #001744;
}
</style>
